import { useEffect } from "react";

const DOMDebugger = () => {
  useEffect(() => {
    console.log("🔍 DOMDebugger est bien monté !");
    const allButtons = Array.from(document.querySelectorAll("button"));
    console.log("🕵️‍♀️ Liste des boutons présents :", allButtons.map(btn => btn.innerText));
    console.log("💻 Structure DOM racine :", document.getElementById("root").innerHTML);
  }, []);

  return null;
};

export default DOMDebugger;
